/* unplugin-vue-components disabled */import script from "./MacthList.vue?vue&type=script&setup=true&lang=js"
export * from "./MacthList.vue?vue&type=script&setup=true&lang=js"

import "./MacthList.vue?vue&type=style&index=0&id=24b868cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b868cc"]])

export default __exports__